import { FormControl, FormGroup } from '@angular/forms';
import { GroupSummary } from 'src/app/core/models/reports/reports.model';
import { Options } from '../../../shared/report-format/report-format.constants';

export const GROUP_CONSTS = {
  HEADER: $localize`Group Summary`,
  LABEL: $localize`Date`,
};
export const GROUP_REPORT_FILE_NAME = 'Group-Summary-Report';

export const GROUP_PDF_REPORT = {
  NAME: 'Group Summary',
  HEADER: {
    GROUP_CODE: 'Group Code:',
    GROUP_NAME: 'Group Name:',
  },
  FOOTER: {
    TOTAL: 'Total'.toUpperCase() + ':',
  },
  COLUMNS: [
    'Location'.toUpperCase(),
    'Name'.toUpperCase(),
    'Total Stops'.toUpperCase(),
    'Total Pkgs'.toUpperCase(),
    'Delivery Stops NET'.toUpperCase(),
    'Delivery Pkgs NET'.toUpperCase(),
    'Pickup Stops NET'.toUpperCase(),
    'Pickup Pkgs NET'.toUpperCase(),
    'Missed Pickup'.toUpperCase(),
    'Missed Del Stop'.toUpperCase(),
    'Missed Del Pkgs'.toUpperCase(),
    'Send-Again COD'.toUpperCase(),
    'Send-Again Paid'.toUpperCase(),
    'Net COD'.toUpperCase(),
    'Offload'.toUpperCase(),
    'Open'.toUpperCase(),
    'Other'.toUpperCase(),
  ],
  DATA_FIELDS: [
    'location',
    'name',
    'totalStops',
    'totalPkgs',
    'deliveryStopsNet',
    'deliveryPkgsNet',
    'pickupStopsNet',
    'pickupPkgsNet',
    'missedPickup',
    'missedDelStop',
    'missedDelPkgs',
    'sendAgainCod',
    'sendAgainPaid',
    'netCod',
    'offload',
    'open',
    'other',
  ] as (keyof GroupSummary)[],
};

type GroupSummaryFormField = {
  date: FormControl<Date>;
  reportFormat: FormControl<Options>;
};

export type GroupSummaryFormGroup = FormGroup<GroupSummaryFormField> | null;
